import _ from "lodash";
import Box from "../../components/box";
import Btn from "../../components/btn";
import Label from "../../components/label";
import h from "../../core/createElement";
import Modal from "../../core/modalEngine";
import report_service from "../../service/report_service";
import { btn_handler, smooth_hide, switchable_element } from "../../utils";
import Input from "../../components/input";
import Spinner from "../../components/spinner";
import axios from "axios";
import RequestBodyBox from "./boxes/request_body_box";
import BorderBox from "../../components/borderbox";
import popupAlerts from "../../core/popupAlerts";
import GenericConfirmModal from "../generic_confirm";
import FileReponseTestCard from "../../components/file_response_test_card";

function ReportTest({ hide, onInit, report: { id, path_name } }) {
    let test_data_template, request_body, format = "";

    const
        between_quotes_regex = /"(.*)"/gm,
        shared = {},
        loading = switchable_element(<Spinner />),
        end_point_label = switchable_element(<Label title="POST" text={`/export/${path_name}`} />),
        response_content = switchable_element(<span class="empty">Vazio</span>),
        request_body_box = switchable_element(<section></section>),
        extentions = [
            { label: "PDF", value: "pdf" },
            { label: "HTML", value: "html" },
            { label: "CSV", value: "csv" },
            { label: "XLSX", value: "xlsx" },
            { label: "XML", value: "xml" }
        ];

    const { disable_btn, enable_btn } = btn_handler(shared);

    const
        get_current_body = () => shared.req_body_box.get_current_body(),
        get_default_model = () => shared.req_body_box.get_default_model(),
        clean_stored_body = () => shared.req_body_box.clean_stored_body();

    const
        on_req_body_change = (v) => {
            request_body = v;
            enable_btn("btn_clean_local");
        },
        show_request_body_box = () => {
            request_body_box.show();
            disable_btn("btn_req_body");
        },
        hide_request_body_box = () => {
            smooth_hide("closing", request_body_box);
            enable_btn("btn_req_body");
        },
        get_test_template = async () => {
            try {
                loading.show();

                const { data } = await report_service.get_test_template(id);

                test_data_template = data;

                request_body_box.switch(
                    <RequestBodyBox
                        hide={hide_request_body_box}
                        shared={shared}
                        name="req_body_box"
                        onChange={on_req_body_change}
                        data={test_data_template}
                        id={id}
                    />
                );

                request_body = get_current_body();

                if (_.isEqual(request_body, get_default_model())) disable_btn("btn_clean_local");

                show_request_body_box();

                loading.hide();
            } catch (e) {
                hide();
                loading.hide();
            };
        },
        copy_to_clipboard = async (object_name, object) => {
            try {
                await navigator.clipboard.writeText(JSON.stringify(object));
                popupAlerts.info(object_name + ' copiado!');
            } catch (err) {
                popupAlerts.danger('Não foi possivel copiar ' + object_name)
            };
        },
        on_format_change = ({ target: { value } }) => {
            format = "/" + value;
            end_point_label.switch(<Label title="POST" text={`/export/${path_name}/${value}`} />);
        },
        clean_body = () => {
            clean_stored_body();
            disable_btn("btn_clean_local");
        },
        try_request_report = async () => {
            try {
                loading.show();

                response_content.back_default();

                const api = axios.create({});

                api.interceptors.request.use(config => {
                    config.meta = config.meta || {}
                    config.meta.startedAt = new Date().getTime();
                    return config;
                },
                    error => {
                        return Promise.reject(error);
                    });

                api.interceptors.response.use(response => {
                    return { ...response, duration: new Date().getTime() - response.config.meta.startedAt };
                }, response => {
                    response.duration = new Date().getTime() - response.config.meta.startedAt;
                    throw response;
                });

                const response = await api.post(`/export/${path_name}${format}`, request_body, {
                    headers: { "Content-Type": "application/json" },
                    responseType: 'blob', validateStatus: (s) => s <= 500
                });

                if (response.status !== 200) {
                    const error = JSON.parse(await response.data.text());
                    
                    GenericConfirmModal.show({ title: error.status, text: error.message, showCancel: false, textConfirm: "Ok" });
                } else {
                    const file = new Blob([response.data], { type: response.headers.getContentType() });

                    const fileURL = URL.createObjectURL(file);

                    response_content.switch(
                        <FileReponseTestCard
                            data={{
                                filename: response.headers['content-disposition'].match(between_quotes_regex)[0].replaceAll('"', ""),
                                size: +response.headers.getContentLength(),
                                content_type: response.headers.getContentType(),
                                exec_time: response.duration,
                                blob_url: fileURL
                            }}
                            removeCard={() => response_content.back_default()}
                        />
                    );
                };

                loading.hide();
            } catch (e) {
                loading.hide();
            };
        };

    onInit(async () => {
        await get_test_template();
    });

    return (
        <section class="flex justify-center h-100">

            {request_body_box.marker()}

            <Box title={"Teste Do Relatório: " + id} containerClass="min-w-450 modal-test-container" buttons={<Btn icon="assets/image/x_white.svg" onClick={() => hide()} color="red" />}>
                <section class="inner-content flex-column">
                    <Input title="Formato" onChange={on_format_change} items={extentions} type="select" />
                    {end_point_label.current()}
                </section>

                <BorderBox title="Corpo da requisição" contentClass="req-btns flex">
                    <Btn title="Exibir" color="blue" shared={shared} name="btn_req_body" onClick={show_request_body_box} />
                    <Btn title="Copiar Modelo" color="purple" shared={shared} name="btn_req_copy_model" onClick={() => copy_to_clipboard('Modelo', shared.req_body_box.get_default_model())} />
                    <Btn title="Copiar Atual" color="purple" shared={shared} name="btn_req_copy_current" onClick={() => copy_to_clipboard('Copo atual', shared.req_body_box.get_current_body())} />
                    <Btn title="Limpar" color="red" containerClass="ml-auto" shared={shared} name="btn_clean_local" onClick={clean_body} />
                </BorderBox>

                <BorderBox title="Resposta">
                    {response_content.current()}
                </BorderBox>

                <section class="flex inner-content justify-end">
                    <Btn title="Enviar" color="green" onClick={try_request_report} />
                </section>

                {loading.marker()}
            </Box>
        </section>
    );
};

const ReportTestModal = new Modal(ReportTest);

export default ReportTestModal;

